export default "__VITE_ASSET__Ci08$uej__"